import { WaterNewContractServiceDto } from '../types/water-new-contract-service-dto';
import { BaseService } from '@app/services/base/classes/base-service';

export class WaterNewContractService extends BaseService {
    constructor(partial: WaterNewContractServiceDto) {
        super(partial);
    }
}
